import { useHistory } from 'react-router-dom';
import { getSubSystem } from './method';

/**
 * 跳转到对应路由
 * @param isSub 是否加上子系统baseUrl
 * @returns
 */
export const usePush = (isSub: boolean = true) => {
  const history = useHistory();
  const replaceUrl = (path: string = getSubSystem()?.homeUrl || '') => {
    const baseUrl = !!isSub ? getSubSystem()?.phoneBaseUrl : '';
    // window.location.href = baseUrl + path;
    history.replace(baseUrl + path);
  };
  const pushUrl = (path: string = getSubSystem()?.homeUrl || '') => {
    const baseUrl = !!isSub ? getSubSystem()?.phoneBaseUrl : '';
    history.push(baseUrl + path);
  };
  return {
    replaceUrl,
    pushUrl,
  };
};
